module.exports = __webpack_public_path__ + "static/eric_bruk-a7671cf1d2d66e469e860f8604d9dd9e.png";